export default __webpack_public_path__ + "static/media/IBimagekneeextensionpreswing2.e7494820.png";